import { useQuery } from "@tanstack/react-query";
import { regionsApi, type Region } from "@/lib/admin-api/regions";

const REGIONS_KEY = "admin-regions";

/** Fetch all regions. Cached for 5 minutes since regions rarely change. */
export function useRegions() {
  return useQuery<{ readonly regions: readonly Region[] }>({
    queryKey: [REGIONS_KEY],
    queryFn: () => regionsApi.list(),
    staleTime: 5 * 60_000,
  });
}
